import { withQuestionnaireFuncs } from 'Context/WithQuestionnaireAnswer';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'Helpers/PropTypes';
import Input from 'Components/UI/BehavioralFormElement/Text/NumberInput';
import { withHousehold } from 'Context/HouseholdContext';
import { ContextIndex } from './FieldList';
import { makeHideable } from '../Hideable';

import './index.css';
import withViewContext from './withViewContext';

class Number extends Component {
  constructor(props) {
    super(props);

    const {
      apiResponse: {
        attributes: { value: numberString },
      },
    } = props;
    const value = numberString ? parseFloat(numberString) : null;

    this.state = {
      value,
      isDone: false,
    };

    this.onChange = this.onChange.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.blurOverride = this.blurOverride.bind(this);
  }

  componentDidMount() {
    const {
      householdId,
      answerKey,
      getQuestionnaireAnswer,
      getIndexedQuestionnaireAnswer,
    } = this.props;
    const index = this.context;

    let promise;
    if (index > -1) {
      promise = getIndexedQuestionnaireAnswer(householdId, answerKey, index);
    } else {
      promise = getQuestionnaireAnswer(householdId, answerKey);
    }

    return promise
      .then((res) => this.setState({ value: parseFloat(res.attributes.value) }))
      .finally(() => this.setState({ isDone: true }));
  }

  componentDidUpdate(prevProps) {
    const { value: prevValue } = prevProps;
    const { triggerBlur, value } = this.props;
    if (triggerBlur && value && value !== prevValue) {
      this.onBlur(value);
    }
  }

  onChange(name, value) {
    const { onChange } = this.props;
    if (value !== null) {
      this.setState({ value });
    }
    onChange(name, value);
  }

  onBlur(v = null) {
    const {
      householdId, uploadValue, answerKey, onBlur,
    } = this.props;
    let { value } = this.state;
    const index = this.context;
    const blur = onBlur(value);
    value = blur || value;
    value = v || value;
    value = value !== null ? value.toString() : null;
    uploadValue(householdId, answerKey, {
      attributes: {
        value,
        index,
      },
    });
  }

  blurOverride() {
    const {
      householdId, uploadValue, answerKey, blurOverride,
    } = this.props;
    let { value } = this.state;
    const index = this.context;
    const blurValue = blurOverride(value);
    value = blurValue !== null ? value.toString() : null;
    uploadValue(householdId, answerKey, {
      attributes: {
        value,
        index,
      },
    });
    this.setState({ value });
  }

  render() {
    const {
      onBlur,
      onChange,
      blurOverride,
      props,
      props: {
        name,
        placeholder,
        value: propValue,
        label,
        test,
        blurOverride: blurOverrideFromProps,
      },
      state: { value, isDone },
    } = this;

    if (!isDone) {
      return null;
    }

    return (
      <div className="questionnaire-input">
        <Input
          {...props}
          name={name}
          test={test}
          label={label || placeholder}
          placeholder={placeholder}
          onBlur={blurOverrideFromProps ? blurOverride : onBlur}
          onChange={onChange}
          value={propValue || value}
        />
      </div>
    );
  }
}

Number.propTypes = {
  name: PropTypes.string.isRequired,
  uploadValue: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
  label: PropTypes.string,
  answerKey: PropTypes.string.isRequired,
  householdId: PropTypes.number.isRequired,
  apiResponse: PropTypes.instanceOf(Object),
  onBlur: PropTypes.func,
  blurOverride: PropTypes.func,
  onChange: PropTypes.func,
  triggerBlur: PropTypes.bool,
  value: PropTypes.number,
  test: PropTypes.string,
  getQuestionnaireAnswer: PropTypes.func.isRequired,
  getIndexedQuestionnaireAnswer: PropTypes.func.isRequired,
};

Number.defaultProps = {
  onBlur: noop,
  blurOverride: undefined,
  onChange: noop,
  triggerBlur: false,
  label: '',
  value: null,
  test: '',
  apiResponse: { attributes: {} },
};

Number.contextType = ContextIndex;

const NumberInput = withHousehold(withQuestionnaireFuncs(withViewContext(Number)));

export default makeHideable(NumberInput);
